/**
 * Environment-related constants
 */

export const DEV_ENVS = ['staging', 'integration', 'development']

export type DevEnvironment = (typeof DEV_ENVS)[number]

export const isDevEnvironment = (env: string): env is DevEnvironment => {
  return DEV_ENVS.includes(env as DevEnvironment)
}
